import { api } from '@/shared/api/client';
import type {
  CreateTenantRequest,
  Tenant,
  UpdateInventorySettingsRequest,
  UpdateTenantRequest,
} from '@/shared/api/types/tenant';

export function listMyTenants(): Promise<Tenant[]> {
  return api.get<Tenant[]>('/api/tenant/my');
}

export function getTenant(id: string): Promise<Tenant> {
  return api.get<Tenant>(`/api/tenant/${id}`);
}

export function updateTenant(id: string, req: UpdateTenantRequest): Promise<Tenant> {
  return api.patch<Tenant>(`/api/tenant/${id}`, req);
}

export function updateTenantInventorySettings(
  id: string,
  req: UpdateInventorySettingsRequest,
): Promise<Tenant> {
  return api.patch<Tenant>(`/api/tenant/${id}/inventory-settings`, req);
}

export function createTenant(req: CreateTenantRequest): Promise<Tenant> {
  return api.post<Tenant>('/api/tenant', req);
}

export interface TenantUser {
  AppUserId: string;
  UserName: string;
  DisplayName: string;
  /** Backend enum-ийг string ("Owner"/"Admin"/"Member") эсвэл int (0/1/2) болгож буцаах боломжтой. */
  Role: number | string;
  Status: number | string;
  JoinedAt: string;
  IsDefaultTenant: boolean;
}
export function listTenantUsers(tenantId: string): Promise<TenantUser[]> {
  return api.get<TenantUser[]>(`/api/tenant/${tenantId}/users`);
}

const ROLE_NAME_TO_INT: Record<string, number> = { Owner: 0, Admin: 1, Member: 2 };
const STATUS_NAME_TO_INT: Record<string, number> = { Active: 0, Inactive: 1, Suspended: 2 };

/** Backend enum-ийг (string эсвэл int) int рүү хувиргана. Танигдаагүй бол 99. */
export function toRoleInt(value: number | string | null | undefined): number {
  if (value == null) return 99;
  if (typeof value === 'number') return value;
  return ROLE_NAME_TO_INT[value] ?? 99;
}
export function toStatusInt(value: number | string | null | undefined): number {
  if (value == null) return 99;
  if (typeof value === 'number') return value;
  return STATUS_NAME_TO_INT[value] ?? 99;
}

export interface PlanHistoryEntry {
  Id: string;
  FromPlan: number;
  FromPlanLabel: string;
  ToPlan: number;
  ToPlanLabel: string;
  ChangedOn: string;
  Reason: string;
  SourceInvoiceNo?: string | null;
}
export function listPlanHistory(tenantId: string): Promise<PlanHistoryEntry[]> {
  return api.get<PlanHistoryEntry[]>(`/api/tenant/${tenantId}/plan-history`);
}

export interface InviteUserRequest {
  Phone: string;
  Role: number;
}
export interface InviteUserResponse {
  Phone: string;
  BoundImmediately: boolean;
  InviteId: string | null;
  TenantUserId: string | null;
}
export function inviteTenantUser(
  tenantId: string,
  req: InviteUserRequest,
): Promise<InviteUserResponse> {
  return api.post<InviteUserResponse>(`/api/tenant/${tenantId}/users/invite`, req);
}

export interface PendingInvite {
  Id: string;
  Phone: string;
  Role: number | string;
  InvitedOn: string;
  ExpiresOn: string;
  InvitedByAppUserId: string | null;
  InvitedByDisplayName: string;
}
export function listPendingInvites(tenantId: string): Promise<PendingInvite[]> {
  return api.get<PendingInvite[]>(`/api/tenant/${tenantId}/invites/pending`);
}
export function cancelInvite(tenantId: string, inviteId: string): Promise<void> {
  return api.post<void>(`/api/tenant/${tenantId}/invites/${inviteId}/cancel`);
}
